import { BackstageOverrides } from '@backstage/core-components';
import { Theme } from '@mui/material/styles';
import { getSurfaceBorder, getThemeTokens, radii } from '../tokens';

export const styledMuiPopover = (
  theme: Theme,
): BackstageOverrides['MuiPopover'] => ({
  paper: {
    backdropFilter: 'blur(18px)',
    border: `1px solid ${getSurfaceBorder(theme)}`,
    borderRadius: radii.lg,
    boxShadow: getThemeTokens(theme).shadow,
    marginTop: theme.spacing(0.75),
    minWidth: theme.spacing(25),
  },
});
